if (!customElements.get("custom-localization-form")) {
  customElements.define(
    "custom-localization-form",
    class CustomLocalizationForm extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.elements = {
          input: this.querySelector(
            'input[name="locale_code"], input[name="country_code"]',
          ),
          panel: document.querySelector(".wt-lang"),
          buttons: document.querySelectorAll("[toggle-localization-drawer]"),
          closeButton: document.querySelector(".wt-lang .close-btn"),
          body: document.querySelector("body"),
          searchInput: document.querySelector(".wt-lang input"),
          countries: document.querySelectorAll(".wt-lang li"),
          overlay: document.querySelector(".wt-lang__overlay"),
        };

        this.addEventListeners = this.addEventListeners.bind(this);
        this.openPanel = this.openPanel.bind(this);
        this.hidePanel = this.hidePanel.bind(this);
        this.searchCountry = this.searchCountry.bind(this);

        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      addEventListeners() {
        this.elements.buttons?.forEach((btn) =>
          btn.addEventListener("click", this.openPanel),
        );
        this.elements.closeButton.addEventListener("click", this.hidePanel);

        this.querySelectorAll("a").forEach((item) =>
          item.addEventListener("click", this.onItemClick.bind(this)),
        );

        this.elements.searchInput.addEventListener("input", this.searchCountry);
        this.elements.overlay.addEventListener("click", this.hidePanel);
      }

      removeEventListeners() {
        this.elements.buttons?.forEach((btn) =>
          btn.removeEventListener("click", this.openPanel),
        );
        this.elements.closeButton.removeEventListener("click", this.hidePanel);

        this.querySelectorAll("a").forEach((item) =>
          item.removeEventListener("click", this.onItemClick.bind(this)),
        );

        this.elements.searchInput.removeEventListener(
          "input",
          this.searchCountry,
        );

        this.elements.overlay.removeEventListener("click", this.hidePanel);
      }

      searchCountry(e) {
        console.log(e);
        const searchQuery = e.target.value.toLowerCase();
        const countries = Array.from(this.elements.countries);

        const filteredCountries = this.filterCountries(countries, searchQuery);

        this.updateCountryVisibility(countries, filteredCountries);
      }

      filterCountries(countries, query) {
        return countries.filter((country) =>
          country.dataset.country.toLowerCase().startsWith(query),
        );
      }

      updateCountryVisibility(countries, filteredCountries) {
        countries.forEach((country) => {
          const shouldBeHidden = !filteredCountries.includes(country);
          country.classList.toggle("hidden", shouldBeHidden);
        });
      }

      hidePanel() {
        this.elements.panel.removeAttribute("open");
        this.elements.body.classList.remove("page-overlay-drawer-on");
      }

      openPanel() {
        this.elements.panel.setAttribute("open", "");
        this.elements.body.classList.add("page-overlay-drawer-on");
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector("form");
        this.elements.input.value = event.currentTarget.dataset.value;

        // if (window.location.href.includes("pl-misbhv.myshopify.com") || window.location.href.includes("misbhv.pl") || window.location.href.includes("127.0.0.1")) {
        //   let url = new URL(window.location.href);
        //   let newUrl = "";
        
        //   let currentDomain = url.hostname;
        
        //   if (url.search) {
        //     newUrl = url.href.replace(currentDomain, "misbhv.com").split("?")[0] + "?country=" + this.elements.input.value + "&" + url.searchParams.toString();
        //   } else {
        //     newUrl = url.href.replace(currentDomain, "misbhv.com") + "?country=" + this.elements.input.value;
        //   }
        
        //   window.location.href = newUrl;
        //   return;
        
        // } else {
        //   if (this.elements.input.value === "PL") {              
        //     let url = new URL(window.location.href);
        //     let currentDomain = url.hostname;
        //     window.location.href = url.href.replace(currentDomain, "misbhv.pl");
        //     return;              
        //   }
        // }
        if (form) form.submit();
      }
    },
  );
}
